import React from 'react';

import createHistory from 'history/createBrowserHistory';
import { Router } from 'react-router-dom';

import App from 'src/App';
import routes from 'src/routes';

const history = createHistory();

export default class Root extends React.Component {
  render() {
    return (
      <Router history={history}>
        <App>{routes}</App>
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/root.js